module.exports = __webpack_public_path__ + "img/1479798302.a9b7e54f.jpg";